var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "partilhar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Ficha",
    transform: "translate(-1465.000000, -840.000000)",
    stroke: "",
    strokeWidth: 1.36
  }, /*#__PURE__*/React.createElement("g", {
    id: "partilhar",
    transform: "translate(1466.000000, 841.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9879502,3.26981278 C13.5959881,4.397606 14.7055357,6.19071584 14.930661,8.25968899",
    id: "Vector",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.15778927,8.30019806 C1.36683419,6.23933852 2.46030008,4.44622829 4.05225764,3.31032145",
    id: "Vector",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.93668819,15.2535469 C5.86935016,15.7322504 6.9306559,16 8.04824224,16 C9.12562767,16 10.1386912,15.7565911 11.0472326,15.310342",
    id: "Vector",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.23517269,9.91482032 C3.46962451,9.91482032 4.47034575,10.9246805 4.47034575,12.1704066 C4.47034575,13.4161326 3.46962451,14.4259936 2.23517269,14.4259936 C1.00072086,14.4259936 0,13.4161326 0,12.1704066 C0,10.9246805 1.00072086,9.91482032 2.23517269,9.91482032 Z M13.7648267,9.91482032 C14.9992786,9.91482032 16,10.9246805 16,12.1704066 C16,13.4161326 14.9992786,14.4259936 13.7648267,14.4259936 C12.5303749,14.4259936 11.5296535,13.4161326 11.5296535,12.1704066 C11.5296535,10.9246805 12.5303749,9.91482032 13.7648267,9.91482032 Z M8.04826371,0 C9.28271554,0 10.2834362,1.00986041 10.2834362,2.25558644 C10.2834362,3.50131247 9.28271554,4.51117249 8.04826371,4.51117249 C6.81381189,4.51117249 5.81309045,3.50131247 5.81309045,2.25558644 C5.81309045,1.00986041 6.81381189,0 8.04826371,0 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon_share.9da850f7e17e3b8af0fe8ed7df4c652f.svg";
export { ForwardRef as ReactComponent };